import { useField, useFormikContext } from "formik";
import { RenderContainer } from "../RenderContainer";
import React, { ReactNode } from "react";
import { Renderer, Renderer2, RendererProps, customField } from "../model";
import _ from "lodash";
import { customString } from "./customString";

const CustomBoolean: React.FC<RendererProps> = ({
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
}) => {
  const { setFieldValue } = useFormikContext();
  const [{ value, ...rest }] = useField(field.name);
  const onChange = (select: string) => {
    const tempValues = _.cloneDeep(value);
    tempValues[index] = { ...tempValues[index], value: select };
    setFieldValue(field.name, [...tempValues]);
  };

  return readOnly ? (
    <React.Fragment>
      {customString(
        customField,
        index,
        readOnly,
        handleOnChange,
        field,
        undefined,
        undefined,
        true
      )}
    </React.Fragment>
  ) : (
    <RenderContainer
      customFieldName={customField.name}
      classWrapper={`${readOnly ? "" : "Boolean"}`}
    >
      <div className="RadioButtons CustomBoolean">
        <div
          className={`Radio ${value[index].value === "True" ? "Checked" : ""}`}
          role="checkbox"
          aria-checked={value[index].value === "True"}
          onClick={() => onChange("True")}
        >
          <input
            id={customField.name + "-true"}
            type="radio"
            name={customField.name}
            value={"True"}
            checked={value[index].value === "True"}
            onChange={() => {}} // Prevent console error about providing a checked attribute but no onChange prop. The onChange is the onClick on the div that wraps this.
          />
          <label className="CustomInput" htmlFor={customField.name + "-true"}>
            Yes
          </label>
        </div>

        <div
          className={`Radio ${
            // deepGet(formikContext.values, fieldName) === (false || "False")
            value[index].value === "False" ? "Checked" : ""
          }`}
          role="checkbox"
          aria-checked={value[index].value === "False"}
          onClick={() => onChange("False")}
        >
          <input
            id={customField.name + "-false"}
            type="radio"
            name={customField.name}
            value={"False"}
            checked={value[index].value === "False"}
            onChange={() => {}} // Prevent console error about providing a checked attribute but no onChange prop. The onChange is the onClick on the div that wraps this.
          />
          <label className="CustomInput" htmlFor={customField.name + "-false"}>
            No
          </label>
        </div>
      </div>
    </RenderContainer>
  );
};

export const customBoolean: Renderer2 = (
  customField,
  index,
  readOnly,
  handleOnChange,
  field
) => (
  <CustomBoolean
    customField={customField}
    index={index}
    readOnly={readOnly}
    handleOnChange={handleOnChange}
    field={field}
  />
);
